// eslint-disable-next-line
import { SkeletonText } from 'skeleton-elements/vue';
export default SkeletonText;